<template>
  <div class="notification">
    <vs-list v-if="!viewMessage">
      <div
        v-for="notification in notificationData"
        :key="notification.id"
        @click="clickItem(notification)"
      >
        <vs-list-item class="list-item-nt">
          <div class="content-item-nt">
            <i
              class="material-icons icon-info"
              :class="notification.checked == 1 ? 'icon-read' : ''"
              >check_circle_outline</i
            >
            <span
              class="message-info"
              v-html="notification.message.substring(0, 60) + '...'"
            ></span>
          </div>
        </vs-list-item>
      </div>
    </vs-list>
    <b-pagination
      v-show="!viewMessage"
      v-if="count > 7"
      size="md"
      v-model="page"
      :total-rows="count"
      :per-page="7"
    />

    <div v-if="notificationData.length < 1">
      <span>Nenhum notificação na sua caixa de entrada!</span>
    </div>
    <vs-row v-if="viewMessage" vs-justify="center">
      <vs-col type="flex" vs-justify="center" vs-align="center">
        <vs-card>
          <div slot="header">
            <h5>Conteúdo da Mensagem: {{ selectedNotification.date }}</h5>
          </div>
          <div>
            <p class="message-side-read" v-html="contentMessage"></p>
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-start">
              <vs-button color="primary" @click="clickBackNotification"
                >Voltar</vs-button
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
//variaveis globais
import { baseApiUrlStock } from "@/global";
//cliente http
import axios from "axios";
//eventos
import { EventBusNotification } from "@/eventBus/eventBusNotification";

export default {
  name: "Notification",
  data() {
    return {
      notificationData: [],
      notificationRead: false,
      selectedNotification: null,
      contentMessage: null,
      viewMessage: false,
      mat: sessionStorage.getItem("@matricula"),
      page: 1,
      count: 0,
      fields: [
        { key: "message", label: "" },
        { key: "date", label: "" },
        { key: "read", label: "" },
      ],
    };
  },
  methods: {
    notificationTimer() {
      axios
        .get(
          `${baseApiUrlStock}/notification/listReadByUser/${this.mat}/${7}/${
            this.page
          }`
        )
        .then((resp) => {
          this.notificationData = resp.data;
          this.count = resp.data[0] != null ? resp.data[0].totalList : 0;
          EventBusNotification.$emit(
            "notificationMessage",
            resp.data[0] != null ? resp.data[0].total : 0
          );
        });
    },
    clickItem(notification) {
      this.viewMessage = true;
      this.contentMessage = notification.message;
      this.selectedNotification = notification;

      if (notification.checked == 0) {
        axios
          .get(`${baseApiUrlStock}/notification/readMessage/${notification.id}`)
          .then((resp) => {
            if (resp.data.error) {
              this.showMessage(
                "Ocorreu algo inesperado ao ler a mensagem",
                "error"
              );
            } else {
              //atualiza icone de mensagem
              this.notificationTimer();
              EventBusNotification.$emit("readMessage");
            }
          });
      }
    },
    clickBackNotification() {
      this.viewMessage = false;
    },
    showMessage(message, type) {
      this.$toasted.show(message, {
        iconPack: "fontawesome",
        position: "top-center",
        className: ["toast-global"],
        type: type,
        duration: 4000,
      });
    },
  },
};
</script>

<style>
.vs-popup--title h3 {
  font-size: 1.5rem !important;
  color: #457bff !important;
}

.list-item-nt {
  cursor: pointer;
}

.list-item-nt:hover {
  background-color: rgba(155, 155, 155, 0.219);
}

.message-info {
  font-size: 17px;
  color: #565658;
}

.vs-list--slot {
  margin-left: 10px !important;
}

.content-item-nt {
  display: flex;
  flex-direction: row;
}

.content-item-nt > i {
  margin-right: 10px;
}

.icon-read {
  color: #288a0a !important;
}

.icon-info {
  font-size: 30px;
  color: rgba(128, 128, 128, 0.658);
}

.message-side-read {
  font-size: 16px;
}
</style>
